import cn from 'classnames'
// Components
import styles from './Certificates.module.scss'
import rootStyles from '../../pages/puppy/[id].module.scss'
import Title from '../Title'
import TextBody from '../TextBody/TextBody'

export default function Certificates ({ dog, isMobile }) {
  const registrations =
    dog?.registrations?.split(',').filter((registration) => !!registration) ||
    []

  const certificates = [
    {
      image: '/puppy/certificates-genetically.svg',
      title: 'Genetically Tested',
      attr: dog?.geneticTesting
    },
    {
      image: '/puppy/certificates-vaccination.svg',
      title: 'Vaccinations and Deworming Records',
      attr: true
    },
    {
      image: '/puppy/certificates-registration.svg',
      title: `${registrations[0]} Registration`,
      attr: !!registrations.length
    },
    {
      image: '/puppy/certificates-microchipped.svg',
      title: 'Microchipped',
      attr: dog?.microchipped
    },
    {
      image: '/puppy/certificates-health.svg',
      title: 'Veterinary or State Health Certificate',
      attr: true
    },
    {
      image: '/puppy/certificates-champion.svg',
      title: 'Champion Bloodline',
      attr: dog?.bloodline
    }
  ]

  return (
    <div className={cn(rootStyles.section)}>
      <Title variant='h2'>Certificates & Registrations</Title>

      <ul className={styles.items}>
        {certificates?.map(({ image, title, attr }, i) => {
          const margin =
            !certificates.length % 2 || isMobile
              ? i !== certificates.length - 1
              : i < certificates.length - 1

          if (attr) {
            return (
              <li
                key={title}
                className={cn({
                  [styles.margin]: margin
                })}
              >
                <div
                  style={{ backgroundImage: `url(${image})`, minHeight: 40 }}
                />

                <TextBody weight='bold'>{title}</TextBody>
              </li>
            )
          }

          return null
        })}
      </ul>
    </div>
  )
}
